import api from 'api/client';
import { ENDPOINTS } from 'api/endpoints';
import { Branch } from 'types/storefront';

type CatalogConfigApi = {
  branches?: Array<{ id?: number | string; name?: string }>;
  Branches?: Array<{ Id?: number | string; Name?: string }>;
};

const branchService = {
  getBranches: async (): Promise<Branch[]> => {
    const response = await api.get<CatalogConfigApi>(ENDPOINTS.CATALOG_CONFIG);
    const raw = response.data.branches || response.data.Branches || [];
    return raw.map((item) => {
      const id = String((item as { id?: number | string; Id?: number | string }).id
        ?? (item as { Id?: number | string }).Id
        ?? '').trim();
      const name = String(
        (item as { name?: string; Name?: string }).name || (item as { Name?: string }).Name || id
      ).trim();
      return { id, name, code: id };
    });
  },
};

export default branchService;
